export default __webpack_public_path__ + "static/media/featured-item-24.927396ab.png";